import {Observable} from 'rxjs';
import {
  map,
} from 'rxjs/operators';

// Only need to create a class inheriting from this if there is special mapping logic
// need to create the dto, like converting a JSON string to a Date object.
// I was thinking of making a mapper that could recurse any object and map the properties
// that look like dates, but I don't think it would be very efficient, and it seemed
// a bit dangerous with how dynamic it would have to be (the mapping wouldn't be able to be checked at compile time).
export abstract class CustomMapper<T> {
  handleListResponse(data$: Observable<T[]>): Observable<T[]> {
    return data$.pipe(
      map((listData) => {
        if (!listData) {
          const stringData = JSON.stringify(listData);
          const className = this.constructor && this.constructor.name;
          throw new Error(`Could not map invalid list value (${stringData}) in class '${className}'`);
        }

        const resultList = listData.map((data) => this.postJsonMapping(data));
        return resultList;
      }),
    );
  }

  handleResponse(data$: Observable<T>): Observable<T> {
    return data$.pipe(
      map((data) => {
        if (!data) {
          const stringData = JSON.stringify(data);
          const className = this.constructor && this.constructor.name;
          throw new Error(`Could not map invalid value (${stringData}) in class '${className}'`);
        }

        const result = this.postJsonMapping(data);
        return result;
      }),
    );
  }

  // All 'Date' properties for this class should be converted in this method.
  abstract postJsonMapping(source: T): T;
}
